import React, { useEffect, useState } from "react";
import mondrian from "core/config/theme";
import styled from "styled-components";
import { Modal } from "mondrian-react";

const ModalWrapper = styled.div`
  > .mdn-Modal.mdn-is-open {
    display: flex;
  }

  .mdn-Modal-header {
    padding-bottom: ${mondrian.spacingStackXs};
    min-height: auto;
  }

  .mdn-Modal-footer {
    .mdn-Button {
      margin-left: 10px;
      min-width: 100px;
      width: auto;
      &:first-child {
        margin-left: 0px;
      }
    }
  }

  @media only screen and (min-width: 768px) {
    .mdn-Modal--sm .mdn-Modal-content {
      height: auto;
    }
  }
`;

export default function ({
  header,
  content,
  footer,
  showModal,
  onClose,
  ariaLabel = "Janela de diálogo",
  ...props
}) {
  const [modalOpen, setModalOpen] = useState(false);
  useEffect(
    function () {
      setModalOpen(showModal);
    },
    [showModal]
  );

  function closeModal() {
    setModalOpen(false);
    onClose && onClose();
  }
  const footerContent = footer ? { action: footer } : undefined;
  return (
    <>
      <ModalWrapper>
        <Modal
          {...props}
          aria-label={ariaLabel}
          role="dialog"
          sm
          data={{
            header: header,
            buttonProps: {
              "aria-label": "Botão fechar",
              type: "button",
              "aria-expanded": false,
            },
            content: content,
            footer: footerContent,
            isOpen: modalOpen,
            onCloseClick: () => closeModal(),
            onEscPress: () => closeModal(),
          }}
          onMouseDown={(event) => {
            if (event.target === event.currentTarget) closeModal();
          }}
        />
      </ModalWrapper>
    </>
  );
}
